function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "logo-main",
  d: "M536.5 865.5V670.9h116.7v194.6c0 38.9 17.4 60.4 49.6 60.4s49.6-21.5 49.6-60.4V670.9h116.7v194.6c0 110-59 164.4-165.7 164.4s-166.9-54.4-166.9-164.4zm530.7 154.3H950.5V670.9h116.7v49.6c20.1-36.9 59.7-59.7 108.7-59.7 75.1 0 121.4 50.3 121.4 151.6v207.3h-116.7V825.2c0-40.9-18.8-59.7-50.3-59.7-40.9 0-63.1 32.2-63.1 71.8v182.5zm811.8-40.3c-23.5 33.5-59 50.3-105.3 50.3-94.6 0-169.7-73.8-169.7-184.5s75.1-184.5 169.7-184.5c46.3 0 81.9 16.8 105.3 50.3v-40.3h116.7V1158H1879V979.5zm-77.1-47.6c49 0 82.5-36.9 82.5-86.5s-33.5-86.5-82.5-86.5-83.2 36.9-83.2 86.5 34.2 86.5 83.2 86.5zm276.4-66.4V670.9H2195v194.6c0 38.9 17.4 60.4 49.6 60.4s49.6-21.5 49.6-60.4V670.9h116.7v194.6c0 110-59 164.4-165.7 164.4-106.5 0-166.9-54.4-166.9-164.4zm390.5-21.5c0-108.7 83.9-183.2 197.3-183.2 112.7 0 181.8 72.5 181.8 183.2v28.8h-264.3c10.1 43.6 40.9 65.1 83.2 65.1 34.9 0 60.4-13.4 81.9-44.3l84.5 49.6c-12.7 26.2-61.7 86.5-165.7 86.5-118.2.2-198.7-77-198.7-185.7zm117.4-40.2h145.6c-7.4-36.2-31.5-55.7-68.4-55.7-35.6 0-65.8 16.7-77.2 55.7z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  className: "letter letter-1"
}, React.createElement("path", {
  d: "M1535.5 1019.8h-116.7V764.2h-83.2v-100h199.9v355.6z",
  className: "st1"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  className: "letter letter-2"
}, React.createElement("path", {
  d: "M1418.5 786.2h117V1020h-117zm-83-122.2h200v100h-200z",
  className: "st1"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  className: "letter letter-3"
}, React.createElement("path", {
  d: "M1335.9 664h199.5v356h-53.1V708.3h-146.4V664zm0 56.4h134.4V1020h-51.7V764.1H1336v-43.7z",
  className: "st1"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  className: "letter letter-4"
}, React.createElement("path", {
  d: "M1520.4 874.9h.7l-52.7 152.1-.7-.7c.7-29.1.7-58.8.7-89.9-6.1 5.4-12.2 10.8-18.9 16.2 2.7-32.4 4.7-63.5 7.4-95.3l-38.5 23.7c0-1.4-.7-2.7-.7-3.4 0-37.2.7-77.1.7-113.6h-83.1V663.3h200.8v20.3c-13.5 41.3-27.7 83.8-40.6 124.4 0 0 .7 0 .7.7l41.9-25.7c-12.2 35.8-24.3 69.6-36.5 104.1v.7c6.6-4.1 12.7-8.9 18.8-12.9",
  className: "st1"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  className: "letter letter-5"
}, React.createElement("path", {
  d: "M1335.5 664.6h200.1V765h-200.1zm200.1 169.1c0 32.4-26.3 58.6-58.6 58.6-32.4 0-58.6-26.3-58.6-58.6 0-32.4 26.3-58.6 58.6-58.6 32.3-.1 58.6 26.2 58.6 58.6m0 127.3c0 32.4-26.3 58.6-58.6 58.6-32.4 0-58.6-26.3-58.6-58.6 0-32.4 26.3-58.6 58.6-58.6 32.3-.1 58.6 26.2 58.6 58.6",
  className: "st1"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  className: "letter letter-6"
}, React.createElement("path", {
  d: "M1546.2 680.6v352.7h-115.8V1020h-12.6V766.4h-81.9v-99.2h197.7v13.3h12.6zm-24.7 327.4V679.3h-173.7v75.2h81.9V1008h91.8z",
  className: "st1"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  className: "letter letter-7"
}, React.createElement("path", {
  d: "M1335.1 664.4h200.4v99.7h-200.4zm83.4 244.9h117V1019h-117zm0-127.5h117v109.7h-117z",
  className: "st1"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  className: "letter letter-8"
}, React.createElement("path", {
  d: "M1518.6 681.3v321.5H1437V746h-85.6v-64.7h167.2zm17.9-17.9h-202.9v100.4h85.6v256.8h117.3V663.4z",
  className: "st1"
}));

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  className: "letter letter-9"
}, React.createElement("path", {
  d: "M1418.6 664h116.9v355.7h-116.9zm-83.3 0h67.5v99.8h-67.5z",
  className: "st1"
}));

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  className: "letter letter-10"
}, React.createElement("path", {
  d: "M1335.9 664h199.5v356h-53.1V708.3h-146.4V664zm0 56.4h134.4V1020h-51.7V764.1H1336v-43.7z",
  className: "st1"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  className: "letter letter-11"
}, React.createElement("path", {
  d: "M1546.2 680.6v352.7h-115.8V1020h-12.6V766.4h-81.9v-99.2h197.7v13.3h12.6zm-24.7 327.4V679.3h-173.7v75.2h81.9V1008h91.8z",
  className: "st1"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 3320.5 1733"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

export default __webpack_public_path__ + "static/media/logo.d8fb6bcd.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/containers/app/logo.svg
// module id = 40
// module chunks = 0